import { http } from '@pendo/http';

export function fetchSettings () {
    return http.get('/api/s/_SID_/user/_UID_/setting').then((res) => res.data);
}

export function fetchSetting (setting) {
    return http.get(`/api/s/_SID_/user/_UID_/setting/${setting.name}`).then((res) => {
        // 204 no content
        if (!res) {
            return {
                name: setting.name,
                value: undefined,
            };
        }

        return res.data;
    });
}

export function updateSetting (setting) {
    return http.put(`/api/s/_SID_/user/_UID_/setting/${setting.name}`, setting).then((res) => res.data);
}

export function deleteSetting (setting) {
    return http.delete(`/api/s/_SID_/user/_UID_/setting/${setting.name}`);
}

export function parseValue (value) {
    try {
        return JSON.parse(value);
    } catch (err) {
        return value;
    }
}
